module.exports = __webpack_public_path__ + "static/media/link.57b5d141.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/link.svg
// module id = 452
// module chunks = 0